export default "/_next/static/images/explore-bg-membership-ca45b18688779d046e59306fd5638436.jpeg";